import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from "react-i18next";
import { useMemo, useState, useEffect } from 'react';
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import DefaultPagination from '../../../../components/Pagination';
import DefaultButton from '../../../../components/Buttons/Default';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get } from '../../../../utils/helpers/api';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { PiDotsThreeOutlineVerticalFill } from 'react-icons/pi';
import { IoListOutline } from 'react-icons/io5';

function AttendancePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [rowData, setRowData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const getAttendance = async () => {
    setLoading(true);
    const data = await get(`/hr/attendance?page=${currentPage}&page_size=${pageSize}`);
    if (data?.success) {
      setRowData(data?.attendances?.data);
      setTotalPages(data.total_pages);
      setTotalRecords(data.total_records);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAttendance();
  }, [currentPage, pageSize, searchParams]);

  const columnDefs = useMemo(() => [
    { 
      field: 'employee.firstname', 
      headerName: t('hr.employeeName'), 
      flex: 1, 
      sortable: true,
      valueFormatter: (params) => `${params.data.employee.firstname} ${params.data.employee.lastname}`
    },
    { field: 'attendance_date', headerName: t('common.date'), width: 160, sortable: true },
    { field: 'check_in_time', headerName: 'Check In', width: 130, sortable: true},
    { field: 'check_out_time', headerName: 'Check Out', width: 140, sortable: true},
    { field: 'total_hours', headerName: 'Total Hours', width: 150, sortable: true},
    { field: 'status', headerName: t('common.status'), width: 120, sortable: true}
  ], [t]);

  const defaultColDef = useMemo(() => ({ resizable: true }), []);

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('hr.attendance')}>
          <DefaultButton color="primary" size="sm" onClick={() => navigate('/hr/attendance/create')}>
            New Attendance
          </DefaultButton>
          <Dropdown isOpen={moreOpen} toggle={() => setMoreOpen(o => !o)} size="sm">
            <DropdownToggle outline color="secondary">
              <PiDotsThreeOutlineVerticalFill />
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem onClick={() => navigate('/hr/attendance/bulk-create')}>
                <IoListOutline size={15} /> Bulk Check In/Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </PageSubHeader>

        <div className="subheader-page-content">
          <div className="ag-theme-alpine" style={{ flex: 1, minHeight: 0 }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              animateRows={true}
              suppressCellFocus={true}
            />
          </div>

          <DefaultPagination 
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={(page) => setCurrentPage(page)} 
          />
        </div>
      </div>
    </SidebarLayout>
  );
}

export default AttendancePage;